import { Component, EventEmitter, OnInit } from '@angular/core';
import {
  DwCardBaseComponent,
  DwComponent,
  DwComponentType,
  DwMetaDataListCardConfigData,
} from '@devwareapps/devware-cap';
import {
  AppMetaDataItemNames,
} from '../../../../../meta-data/app-meta-data.service';

import { CourseCardComponent } from '../course-card/course-card.component';

@DwComponent<DwMetaDataListCardConfigData>({
  name: 'Courses-Card-Redesign',
  key: 'coursesCardRedesign',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.Course,
  configData: {
    contentItemDefinitions: [{
      display: 'Main',
      contentItemKey: 'main'
    }]
  }
})
@Component({
  selector: 'app-courses-card-redesign',
  templateUrl: './courses-card-redesign.component.html',
  styleUrls: ['./courses-card-redesign.component.scss']
})
export class CoursesCardRedesignComponent extends CourseCardComponent {
  
  get ringTone(): 'neutral' | 'brand' | 'success' | 'info' {
    if (this.availableForPurchase) return 'brand';
    if (this.endorsed || this.progressPercent >= 90) return 'success';
    if (this.progressPercent > 0) return 'brand';
    return 'neutral';
  }

 }
